export const environment = {
    production: false,
    firebaseConfig : {
        apiKey: "AIzaSyC-x-gOLflx1P0WWgbvVB_7zGBMQKMlLac",
        authDomain: "routigo-2b763.firebaseapp.com",
        databaseURL: "https://routigo-2b763-default-rtdb.firebaseio.com",
        projectId: "routigo-2b763",
        storageBucket: "routigo-2b763.firebasestorage.app",
        messagingSenderId: "8945104670",
        appId: "1:8945104670:web:b4e639f0dd2aa28bb57b0f",
        measurementId: "G-TH17KY86S2"
    },
    googleMapsApiKey: "AIzaSyBWUQ52noiOjGueynvJGXYitd8uMebJghE",
    wompi: {
        publicKey: "pub_test_GJO5KYyvpqrHb5exC17PeUE6WpJ2Wtzp",
        integrityKey: "test_integrity_haNqrwydDX73ICCBKj78zaWZ6WPuXdw4",
        apiUrl: "https://sandbox.wompi.co/v1",
        currency: 'COP',
        redirectUrl: 'https://localhost:4200/public/payment-response'
    }
};